import { useMutation } from "@apollo/client";
import { ARCHIVE_ASSET } from "../gql";
import { GET_ASSETS_BY_ORGANIZATION } from "../gql";

interface ArchiveAssetResult {
  archiveAsset: (assetId: string, userId: string) => Promise<void>;
  loading: boolean;
  error?: Error;
}

/**
 * Hook for archiving an asset
 */
export function useArchiveAsset(organizationId: string): ArchiveAssetResult {
  const [archiveMutation, { loading, error }] = useMutation(ARCHIVE_ASSET, {
    refetchQueries: [
      {
        query: GET_ASSETS_BY_ORGANIZATION,
        variables: { organizationId },
      },
    ],
  });

  const archiveAsset = async (
    assetId: string,
    userId: string,
  ): Promise<void> => {
    await archiveMutation({
      variables: {
        id: assetId,
        archivedAt: new Date().toISOString(),
        archivedByUserId: userId,
      },
    });
  };

  return {
    archiveAsset,
    loading,
    error: error ? new Error(error.message) : undefined,
  };
}
